import { Injectable } from "@angular/core";
import { RestService } from "@stdoutsrl/design-kit";
import { api } from "../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class PlanService {
  constructor(private rest: RestService) {}

  getPlans() {
    return this.rest.get(api.endpoint.plans);
  }

  subscribeToPlan(id: number) {
    return this.rest.get(api.endpoint.subPlan + id);
  }
}
